// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KpMm3","right":"styles_right__3HLdM"};